var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from 'react';
import { styled } from 'linaria/react';
import { usePrice } from '@jetshop/core/hooks/usePrice';
const Wrapper = /*#__PURE__*/styled('div')({
  name: "Wrapper",
  class: "wfsqmst"
});
const NormalPrice = /*#__PURE__*/styled('div')({
  name: "NormalPrice",
  class: "n77d0ua"
});
const OldPrice = /*#__PURE__*/styled('div')({
  name: "OldPrice",
  class: "o1v23gro"
});
const NewPrice = /*#__PURE__*/styled('div')({
  name: "NewPrice",
  class: "nsirej0"
});

const PriceComponent = _a => {
  var {
    className,
    style,
    negative
  } = _a,
      props = __rest(_a, ["className", "style", "negative"]);

  const {
    hasDiscount,
    formattedPricing
  } = usePrice(props);
  return React.createElement(Wrapper, Object.assign({
    className: className,
    style: style
  }, props, {
    "data-flight-price": ""
  }), hasDiscount ? React.createElement(React.Fragment, null, React.createElement(NewPrice, {
    className: "new-price"
  }, formattedPricing.price), React.createElement(OldPrice, {
    className: "old-price"
  }, formattedPricing.previousPrice)) : React.createElement(NormalPrice, {
    className: "price"
  }, negative && '-', formattedPricing.price));
};

PriceComponent.Wrapper = Wrapper;
PriceComponent.Normal = NormalPrice;
PriceComponent.Old = OldPrice;
PriceComponent.New = NewPrice;
export default PriceComponent;

require("../../../../.linaria-cache/node_modules/@jetshop/ui/Price/Price.linaria.css");